import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';
import { validateInformationCsv } from '@/utils/informationCsvValidation';
import { formatInformationCell } from '@/utils/informationPreview';

const InformationUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (_data: ParsedCSVData) => {
    showToast('アップロードを受け付けました。処理状況はアップロード一覧で確認してください');
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">お知らせCSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">
            📋 CSVファイルのフォーマットと注意事項
          </h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>
              ファイル形式：CSV形式（.csv）のみ / サイズ 10MB 以下 / 文字コード UTF-8（BOM
              可）または Shift_JIS（旧環境の CSV をそのまま利用可能）
            </li>
            <li>
              Book / Coupon と同じ 3 行構成：1 行目＝定義名 / 2 行目＝日本語表示名 / 3
              行目以降＝データ（最大 500 行）
            </li>
            <li>
              1 行 = 1 お知らせ。information_name（半角英数と _ の 1〜64 桁）が一致する既存の
              お知らせは上書き更新され、CSV に含まれないお知らせは削除されません
            </li>
            <li>
              start_at / end_at は YYYY/M/D H:MM（JST）。end_at 空欄は無期限。start_at は end_at
              より前であること
            </li>
            <li>
              platform は 3 桁（web/ios/android, 1=表示/0=非表示。000 は不可。Excel
              で編集する場合は先頭の 0 が落ちないよう列を文字列書式にすること）
            </li>
            <li>
              本文（body）は 2000 文字以内・許可タグのみの HTML（p / br / a / strong / em / u / ul
              / ol / li / img / div）。リンクは a タグ（href は / 始まりの相対パス または https://
              始まりのみ、target は _blank のみ）。画像は img タグ（src は href と同じ制約、alt
              可、width は数字または数字+%）。配置は div の align（left / center / right
              のみ）。改行は &lt;br&gt; で表現
            </li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Information"
          customValidate={validateInformationCsv}
          formatCell={formatInformationCell}
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default InformationUpload;
